<div class="sg-success-snackbar">
    <span class="sg-success-snackbar-icon" aria-hidden="true">&#10003;</span>
    <p class="sg-success-snackbar-message mb-0">{{snackbarMessage}}</p>
    <button
        *ngIf="isUndoAvailble"
        mat-button
        type="button"
        (click)="onUndoClick(true)"
        class="sg-success-snackbar-undo"
    >
        UNDO
    </button>
</div>